<div
  class="mobi-ui-height-full"
  [class.mobi-ui-card-image-major]="image"
  [class.mobi-ui-card-major]="!image"
>
  @if (image) {
    <div class="mobi-ui-card-image-wrapper-major">
      <img [src]="image" [alt]="title" />
    </div>
  }
  <div
    [class.mobi-ui-card-image-content-major]="image"
    [class.mobi-ui-card-content-major]="!image"
  >
    <h4>{{ title }}</h4>
    @if (text) {
      <mobi-text [data]="text" />
    }

    @if (link) {
      <a [href]="link" class="w-full mobi-ui-margin-t-sm mobi-ui-btn-major is-squared">
        {{ 'learn_more' | texts: { context: 'primcalc', default: 'Mehr Erfahren' } }}
      </a>
    }
  </div>
</div>
